(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !window.DesignMode) return;
  try {
    
  // Summary
   function Sommaire(container){
     this.container = container;
     this.uls = [document.createElement('ul')];
     this.buildStructure();
   };
 
   Sommaire.prototype.buildStructure = function(){
     var titles = this.container.querySelectorAll('h2, h3, h4, h5');
     var lastLvl = 0
     for(var i = 0; i < titles.length; i++){
       var title = titles[i];
       var lvl = parseInt(title.tagName.replace('H', '')) - 1;
       if(lvl - lastLvl > 1){
         throw "Erreur dans la structure des titres, Saut d'un h" + (lastLvl + 1) + " vers h" + (lvl + 1);
       }
       var lastLvl = lvl;
       var li = document.createElement('li');
       var a = document.createElement('a');
       a.setAttribute('href', '#');
       a.textContent = title.textContent;
       li.appendChild(a);
       if(!this.uls[lvl - 1]){
         var ul = document.createElement('ol');
         this.uls[lvl - 1] = ul;
         this.uls[lvl - 2].lastChild.appendChild(ul);
       }
       this.uls[lvl] = null;
       this.uls[lvl - 1].appendChild(li);
       this.bindScroll(a, title);
     }
   };
 
   Sommaire.prototype.bindScroll = function(a, title) {
     a.addEventListener('click', function(e){
       e.preventDefault();
       document.documentElement.scrollTop = title.offsetTop - 80;
     });
   }
 
   Sommaire.prototype.appendTo = function(element){
     element.appendChild(this.uls[0]);
   };
 
   var s = new Sommaire(document.querySelector('.article-content'));
   s.appendTo(document.querySelector('#summary'));
 
   // Show-Hide
   const summaryTriger = document.querySelector("#summary-show-hide");
   const summary = document.querySelector("#summary");
   let summaryHeight = summary.offsetHeight;
   summary.style.height = "50px";
   summaryTriger.addEventListener('click', function() {
     if(this.innerHTML == 'afficher') {
       this.innerHTML = 'masquer';
       summary.style.height = summaryHeight + 'px';
     } else {
       this.innerHTML = 'afficher';
       summary.style.height = "50px";
     }
   });
 
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection"] && !window.DesignMode) return;
  try {
    
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

  } catch(e) { console.error(e); }
})();
})();
